import React, { Component } from 'react'
import { connect } from 'react-redux';

import PusherContext from '../../../_contexts/PusherContext'

import { telehealthActions } from '../../../_actions/telehealth.actions';

const withSocketService = (WrappedComponent) => {
  class DataService extends Component
  {
    static contextType = PusherContext

    constructor(props) {
      super(props)

      this.state = {
        online: []
      }

      this.messagesInterval = false;
      this.telehealthInterval = false;

      this.handleTyping = this.handleTyping.bind(this)
    }

    componentDidMount() {
      if (this.props.match.params && this.props.match.params.id) {
        this.loadTelehealth(this.props.match.params.id)
        this.loadMessages(this.props.match.params.id)
      }
    }

    componentDidUpdate(prevProps) {
      if (!prevProps.telehealth && this.props.telehealth) {
        if (this.context.connection.state === 'unavailable') {
          this.initiatePolling()
        }

        this.initiateSocket();
      }
    }

    componentWillUnmount() {
      this.props.dispatch(telehealthActions.clearState())

      this.unSubcribeChannels()

      this.disablePolling()
    }

    initiateSocket() {
      this.presenceChannel = this.context.subscribe(`presence-telehealth_msg.${this.props.telehealth.id}`)
        .bind('pusher:subscription_succeeded', data =>  {
          this.setState({
            online: Object.keys(data.members)
              .filter(memberId => {
                return parseInt(memberId) !== parseInt(this.props.currentUser.UserId)
              })
              .map(key => {
                return {
                  ...data.members[key],
                  typing: false
                }
              })
          })
        })
        .bind('pusher:member_added', data => {
          this.setState({
            online: [...this.state.online, {...data.info, typing: false}]
          })
        })
        .bind('pusher:member_removed', data => {
          this.setState({ 
            online: this.state.online.filter(online => {
              return online.userId !== data.id
            })
           })
        })
        .bind('client-typing', data => {
          this.setState({
            online: this.state.online.map(online => {
              return {
                ...online,
                typing: online.userId === data.userId ? data.typing : online.typing
              }
            })
          });
        })
        .bind('messageCreated',  message => {
          this.props.dispatch(telehealthActions.prependMessage(message))
        })

      this.privateChannel = this.context.subscribe(`presence-telehealth_room.${this.props.telehealth.id}`)
        .bind('telehealthClientUpdated', telehealth => {
          this.props.dispatch(telehealthActions.setTelehealth(telehealth))
        })

      this.context.connection.bind('state_change', this.connectionChange, this)
    }

    connectionChange(state) {
      if (state.current === 'connected') {
          this.disablePolling()
      } else if (state.current === 'unavailable' || state.current === 'failed') {
        this.initiatePolling()
      }
    }

    handleTyping(currentUser, typing) {
      if (this.presenceChannel) {
        this.presenceChannel.trigger('client-typing', {
          typing: typing,
          userId: currentUser.UserId,
          firstName: currentUser.FirstName,
          lastName: currentUser.LastName,
          profileUrl: currentUser.profileUrlSizes ? currentUser.profileUrlSizes.sml : currentUser.ProfileUrl
        });
      }
    }

    initiatePolling() {
      if (this.telehealthInterval === false) {
        this.loadTelehealth(this.props.telehealth.id)

        this.telehealthInterval = setInterval(() => {
          this.loadTelehealth(this.props.telehealth.id)
        }, 5000)
      }

      if (this.messagesInterval === false) {
        this.loadMessages(this.props.telehealth.id)

        this.messagesInterval = setInterval(() => {
          this.loadMessages(this.props.telehealth.id)
        }, 5000)
      }
    }

    disablePolling() {
      clearInterval(this.messagesInterval)
      clearInterval(this.telehealthInterval)
    }

    loadMessages(telehealthId) {
      this.props.dispatch(telehealthActions.getTelehealthMessages(telehealthId))
    }
  
    loadTelehealth(telehealthId) {
      this.props.dispatch(telehealthActions.getTelehealthById(telehealthId))
    }

    unSubcribeChannels() {
      if (this.presenceChannel) {
        this.presenceChannel.unbind();
        this.context.unsubscribe(`presence-telehealth_msg.${this.props.telehealth.id}`)
      }

      if (this.privateChannel) {
        this.privateChannel.unbind()
        this.context.unsubscribe(`presence-telehealth_room.${this.props.telehealth.id}`)
      }

      this.context.connection.unbind('state_change', this.connectionChange, this)
    }

    render() {
      return <WrappedComponent
        {...this.props}
        online={this.state.online}
        isTyping={this.handleTyping}
      />
    }
  }

  const mapStateToProps = state => {
    return {
      currentUser: state.user.currentUser,
      telehealth: state.telehealth.details
    }
  }

  return connect(mapStateToProps)(DataService)
}

export default withSocketService